module.exports = __webpack_public_path__ + "img/speaker.63981e64.svg";